import styled from 'styled-components';
import { customTextColor } from '../../../constants/CommonStyles';

export const L16B = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  ${customTextColor}
`;
